const dayMap = {
  Sun: 'Sunday',
  Mon: 'Monday',
  Tue: 'Tuesday',
  Wed: 'Wednesday',
  Thu: 'Thursday',
  Fri: 'Friday',
  Sat: 'Saturday',
};

const monthMap = {
  Jan: 'January',
  Feb: 'February',
  Mar: 'March',
  Apr: 'April',
  May: 'May',
  Jun: 'June',
  Jul: 'July',
  Aug: 'August',
  Sep: 'September',
  Oct: 'October',
  Nov: 'November',
  Dec: 'December',
};

const getColorHexCode = (colorToCheck, colorsDictionary) => {
  if (!colorsDictionary || !colorsDictionary.length) return '#FFFFFF';
  const foundColor = colorsDictionary.find(
    (colorDictionaryItem) => colorDictionaryItem.permanentName === colorToCheck,
  );
  if (!foundColor) return '#FFFFFF';
  return foundColor.hex;
};

const titleCaseString = (string) => {
  const lowerString = string.toLowerCase();
  const splitString = lowerString.split(' ');
  const titleCaseArray = splitString.map(
    (word) => word.charAt(0).toUpperCase() + word.slice(1),
  );
  return titleCaseArray.join(' ');
};

const stringDateConvert = (d) => {
  // Converts string Dates like 2020-05-30
  const date = new Date(d);
  const year = date.getFullYear();
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const monthIndex = date.getMonth();
  const monthName = months[monthIndex];
  const day = date.getDate();

  return `${monthName} ${day}, ${year}`;
};

const fullDateString = (date) => {
  const dateString = date.toDateString();
  const parts = dateString.split(' ');
  const day = dayMap[parts[0]];
  const month = monthMap[parts[1]];
  let dayNumber = parts[2];
  if (dayNumber < 10) {
    dayNumber = dayNumber.substring(dayNumber.length - 1);
  }
  if (dayNumber === '11' || dayNumber === '12' || dayNumber === '13') {
    dayNumber += 'th';
  } else if (dayNumber.substring(dayNumber.length - 1) === '1') {
    dayNumber += 'st';
  } else if (dayNumber.substring(dayNumber.length - 1) === '2') {
    dayNumber += 'nd';
  } else if (dayNumber.substring(dayNumber.length - 1) === '3') {
    dayNumber += 'rd';
  } else {
    dayNumber += 'th';
  }
  return `${day} ${month} ${dayNumber} ${parts[3]}`;
};

export default {
  getColorHexCode,
  titleCaseString,
  fullDateString,
  stringDateConvert,
};
